module.exports = __webpack_public_path__ + "img/vegan-bloemkoolcurry-met-kikkererwten.db174f9a.jpeg";